const translations = {
  "en": {
    "and": "and",
    "By subscribing, you agree to our": "By subscribing, you agree to our",
    "Privacy Policy": "Privacy Policy",
    "Terms of Use": "Terms of Use",
    "Your free trial ends on [Date, Time]. On that date, your subscription will auto-renew at $299.99/year unless you cancel at least 24 hours beforehand. No charges if canceled within 7 days.": "Your free trial ends on [Date, Time]. On that date, your subscription will auto-renew at $299.99/year unless you cancel at least 24 hours beforehand. No charges if canceled within 7 days."
  },
  "zh-tw": {
    "and": "和",
    "By subscribing, you agree to our": "訂閱即表示你同意我們的",
    "Privacy Policy": "隱私權政策",
    "Terms of Use": "使用條款",
    "Your free trial ends on [Date, Time]. On that date, your subscription will auto-renew at $299.99/year unless you cancel at least 24 hours beforehand. No charges if canceled within 7 days.": "您的免費試用期將於 [Date, Time] 結束。屆時您的訂閱將自動續訂，費率為 $299.99/年；如需取消，請至少提前 24 小時操作。7 天內取消則不收取費用。"
  }
};

export default translations;
